var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HeadPortrait"},[_c('img',{attrs:{"src":this.$store.state.userPhoto,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }